<template>
    <TypeEditUsage></TypeEditUsage>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TypeEditUsage = defineAsyncComponent(() =>
    import("../../components/Engineering/TypeEditUsage.vue")
);

export default {
    name: "ENG_TypeEditUsage", //The name you are in should not equal the name of the component you are importing.
    components: { TypeEditUsage, AuthLayout },
};
</script>
